import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedComparisonRunScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedComparisonRunScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  runInstanceId?: number | null;
  ruleId?: number | null;
  severity?: string;
  isActive?: boolean;
}

const useFetchPaginatedComparisonRunScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  runInstanceId,
  ruleId,
  severity,
  isActive,
}: IuseFetchPaginatedComparisonRunScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const result = await getPaginatedComparisonRunScoringConfigs({
        page,
        pSize,
        runInstanceId,
        ruleId,
        severity,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, runInstanceId, ruleId, severity, isActive, setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedComparisonRunScoringConfigs;
